(() => {
  if (customElements.get('mbs-slideshow')) return;
  customElements.define('mbs-slideshow', class extends HTMLElement {
    connectedCallback() {
      this.events = new AbortController();
      const on = (target, event, callback) => target.addEventListener(event, callback, {signal:this.events.signal});
      this.slides = [...this.querySelectorAll('[data-slide]')];
      if (this.slides.length < 2) return;
      this.index = 0;
      this.counter = this.querySelector('[data-current]');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.dataset.autoplay !== 'true' || this.motion.matches;
      this.hovered = false;
      this.focused = false;
      this.visible = false;
      this.querySelectorAll('[data-controls]').forEach(e => e.hidden = false);
      const select = index => { this.show(index, true); this.schedule(); };
      on(this.querySelector('[data-prev]'), 'click', () => select(this.index - 1));
      on(this.querySelector('[data-next]'), 'click', () => select(this.index + 1));
      on(this, 'pointerenter', event => {if (event.pointerType === 'mouse') {this.hovered = true; this.schedule();}});
      on(this, 'pointerleave', event => {if (event.pointerType === 'mouse') {this.hovered = false; this.schedule();}});
      on(this, 'focusin', () => {this.focused = true; this.schedule();});
      on(this, 'focusout', () => queueMicrotask(() => {this.focused = this.contains(document.activeElement); this.schedule();}));
      on(document, 'visibilitychange', () => this.schedule());
      on(this.motion, 'change', () => {if (this.motion.matches) {this.paused = true; this.finishTransition?.();}  this.schedule();});
      on(this, 'keydown', event => {
        if (!['ArrowLeft','ArrowRight'].includes(event.key)) return;
        event.preventDefault(); select(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        this.querySelector(event.key === 'ArrowRight' ? '[data-next]' : '[data-prev]').focus();
      });
      const stage = this.querySelector('.mbss__stage');
      let start;
      let suppressClick = false;
      on(stage, 'pointerdown', event => {
        if (event.pointerType === 'mouse' || event.target.closest('button')) return;
        start = {x:event.clientX,y:event.clientY};
      });
      on(stage, 'pointerup', event => {
        if (!start) return;
        const dx = event.clientX - start.x, dy = event.clientY - start.y;
        start = null;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) {
          suppressClick = true; select(this.index + (dx < 0 ? 1 : -1));
          clearTimeout(this.clickTimer); this.clickTimer = setTimeout(() => suppressClick = false, 400);
        }
      });
      on(stage, 'pointercancel', () => {start = null;});
      stage.addEventListener('click', event => {if (suppressClick) {event.preventDefault();event.stopPropagation();suppressClick=false;}}, {capture:true,signal:this.events.signal});
      on(document, 'shopify:block:select', event => {
        const slide = event.target.closest('[data-slide]');
        const index = this.slides.indexOf(slide);
        if (index >= 0) {this.paused = true;select(index);}
      });
      this.observer = new IntersectionObserver(entries => {this.visible = entries[0].isIntersecting;this.schedule();}, {threshold:0.1});
      this.observer.observe(this);

    }
    show(index, announce = false) {
      // Settle an interrupted transition before accepting another navigation.
      this.finishTransition?.();
      const previous = this.index;
      const next = ((index % this.slides.length) + this.slides.length) % this.slides.length;
      if (next === previous) return;
      const direction = index > previous ? 1 : -1;
      const outgoing = this.slides[previous];
      const incoming = this.slides[next];
      const stage = this.querySelector('.mbss__stage');
      const fromHeight = stage.getBoundingClientRect().height;
      this.index = next;
      this.slides.forEach((slide, i) => slide.hidden = i !== next);
      if (!this.motion.matches && incoming.animate) {
        const toHeight = stage.getBoundingClientRect().height;
        outgoing.hidden = false;
        outgoing.classList.add('mbss__slide--outgoing');
        outgoing.inert = true;
        outgoing.setAttribute('aria-hidden', 'true');
        const timing = {duration: 420, easing: 'cubic-bezier(.22,.61,.36,1)', fill: 'both'};
        const animations = [
          outgoing.animate([{transform:'translateX(0)'}, {transform:`translateX(${-direction * 100}%)`}], timing),
          incoming.animate([{transform:`translateX(${direction * 100}%)`}, {transform:'translateX(0)'}], timing)
        ];
        if (Math.abs(fromHeight - toHeight) > 1) {
          animations.push(stage.animate([{height:`${fromHeight}px`}, {height:`${toHeight}px`}], timing));
        }
        let finished = false;
        const finish = () => {
          if (finished) return;
          finished = true;
          outgoing.hidden = true;
          outgoing.classList.remove('mbss__slide--outgoing');
          outgoing.inert = false;
          outgoing.removeAttribute('aria-hidden');
          animations.forEach(animation => animation.cancel());
          if (this.finishTransition === finish) this.finishTransition = null;
        };
        this.finishTransition = finish;
        Promise.all(animations.map(animation => animation.finished)).then(finish, finish);
      }
      this.counter.textContent = this.index + 1;
      if (announce) this.querySelector('[data-status]').textContent = `Slide ${this.index + 1} of ${this.slides.length}`;
    }
    schedule() {
      clearTimeout(this.timer);
      if (this.paused || this.hovered || this.focused || !this.visible || document.hidden) return;
      this.timer = setTimeout(() => {this.show(this.index + 1);this.schedule();}, Number(this.dataset.interval) || 6000);
    }
    disconnectedCallback() {
      this.finishTransition?.();
      this.events?.abort();this.observer?.disconnect();clearTimeout(this.timer);clearTimeout(this.clickTimer);
    }
  });
})();
